<template>
    <TopNav></TopNav>
		<h1>Age Calculator</h1>
		<fieldset>
      <legend>Age Calculator</legend>
      <label for="birthdate">Birth date:</label> <input type="date" v-model="birth" id="birthdate">
			<br>
      Age: <span class="blue">{{ age }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import moment from 'moment'

export default {
  name: "Age",
  data() {
    return {
      birth: "",
    }
  },
  components: {
    TopNav
  },
  computed: {
    age: function () {
      let a = moment(this.birth);
      let b = moment(new Date());
      let age = b.diff(a, 'years', true).toFixed(3);
      return Number(age);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 110px;
}

footer section a {
  margin: 20px;
}

.blue {
  color: blue;
}
</style>
